export default function isLoggedIn() {
  const token = localStorage.getItem("kloka:token:data");
  const role = localStorage.getItem("kloka:role"); 
  const type = localStorage.getItem("kloka:type"); 
  const categories = localStorage.getItem("kloka:categories"); 
  
  if (token && role && type && categories) {
    return true;
  } else {
    return false;
  }
}
